// client/src/components/login/ForgotPasswordPage.js
import React from 'react';
import ForgotPasswordForm from './ForgotPasswordForm';
import { useAuth } from '../../context/AuthContext';  // Import useAuth
import { Navigate } from 'react-router-dom'; // Import Navigate
import LoadingSpinner from '../common/LoadingSpinner';
import './ForgotPasswordPage.css'


function ForgotPasswordPage() {
    const { isLoggedIn, loading } = useAuth(); // Get isLoggedIn AND loading

    if (loading) {
        return <LoadingSpinner />; // Use the LoadingSpinner
    }


    if (isLoggedIn) {
        return <Navigate to="/dashboard" replace />; // Redirect
    }

    return (
        <div className="forgot-password-page">
            <ForgotPasswordForm />
        </div>
    );
}

export default ForgotPasswordPage;